import api from '../api-methods';

const proxyAdmin = process.env.VUE_APP_ENV === 'local' ? '/proxy_admin' : process.env.VUE_APP_ADMIN
const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

const nps = {
	// 获取banner
	addNps: payload => {
		return api.post(proxyAdmin + `/v1/nps`, payload)
	},
	isShowNps: (id, payload) => {
		return api.get(proxyAdmin + `/v1/nps/fill/${id}/${payload.channel}`)
	},
	sendEmail:(data)=>{
		return api.get(proxyApi+`/v3/sharing_cvs/${data.token}`,{recipient_email:data.recipient_email,type:'email',hideProfile: data.hideProfile, origin: 'pc'})
	}
}
export default nps;